import { SpinnerGap } from '@phosphor-icons/react';
import clsx from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-10 h-10',
  };

  return (
    <SpinnerGap className={clsx('animate-spin text-primary-500', sizeClasses[size], className)} weight="light" />
  );
}
